<template>
	<div class="container container-fluid">
		<div class="header">
			<img class="img-fluid logo" :src="headerImg">
		</div>
		<div v-for="item in bgList">
			<img :src="item" class="img-fluid" />
		</div>
		<div class="footer">
			<div>@Bản quyền <span v-html="domain"></span> 2022</div>
		</div>
		<div class="online-area" :style="online_area_css" @click="jumpOnline()">
			<img class="img-fluid " src="../assets/customer.blue.png">
		</div>
		<div class="download-area" :style="download_area_css" @click="install()">
			<img class="img-fluid swing animated infinite " src="../assets/download_blue.png">
		</div>

		<div class="footer-fix">
			<img class="img-fluid footer-logo" :src="brandIcon" />
			<div class="footer-center">
				<div class="footer-fix-title">{{appName}}</div>
				<div class="footer-fix-desc">Hàng vạn người chơi Tỉ lệ trúng cao</div>
				<div>
					<img class="img-fluid star" src="../assets/star.png" />
				</div>
			</div>
			<div class="footer-fix-btn">
				<button type="button" @click="install()" data-loading-text="Loading..." class="btn btn-primary">
					Vào APP
				</button>
			</div>
			<div class="clear"></div>
			<div class="comment">
				<div class="comment-one">Đăng ký nhận khuyến mãi</div>
				<div class="comment-two"> Một bước thành danh</div>
				<div class="comment-three">Mỹ nhân luôn bên bạn</div>
			</div>
		</div>

		<div class="scrollsidebar" id="scrollsidebar" :style="showQrcode" >
			<div>
				<vue-qr :logoSrc="brandIcon" :text="qrcodeUrl" :size="130" :margin="2"></vue-qr>
				<div class="qr-instruction">Cài đặt App</div>
			</div>
		</div>

		<div class="offcanvas offcanvas-bottom" tabindex="-1" :class="showProgress ? 'show' : ''" id="offcanvasBottom"
			aria-labelledby="offcanvasBottomLabel">
			<div class="offcanvas-header">
				<h6 class="offcanvas-title" id="offcanvasBottomLabel">Hướng dẫn cài đặt APP</h6>
				<button type="button" @click="closeDownload()" class="btn-close" data-bs-dismiss="offcanvas"
					aria-label="Close"></button>
			</div>
			<div class="offcanvas-body small">
				<div :class="download_progress">
					<div class="progress">
						<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
							:aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="width"></div>
					</div>
					<div class="allow_desc" style="text-align: left;">Đang tải xuống APP, xin hãy kiên nhẫn chờ đợi!</div>
					<div>
						<button type="button" @click="viewCourse()" class="btn btn-link">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
								class="bi bi-chevron-double-up" viewBox="0 0 16 16">
								<path fill-rule="evenodd"
									d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z" />
								<path fill-rule="evenodd"
									d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
							</svg>
							&nbsp;Click để xem hướng dẫn cài đặt
						</button>
					</div>
				</div>
				<div :class="showTrust">
					<div class="allow_title">Tải xong</div>
					<div class="allow_desc">Click vào nút One Click Trust để hoàn tất cài đặt</div>
					<button type="button" @click="allowIos()" class="btn btn-primary allow_btn">Tin tưởng One Touch</button>
				</div>
			</div>
		</div>


		<div :class="showCourse ? 'show offcanvas offcanvas-bottom offcanvas_zhiyin' : 'offcanvas offcanvas-bottom offcanvas_zhiyin'"
			tabindex="-10" id="offcanvasBottom2" aria-labelledby="offcanvasBottomLabel">
			<div class="offcanvas-header">
				<h6 class="offcanvas-title">Hướng dẫn cài đặt giảng dạy</h6>
				<button type="button" @click="closeCourse()" class="btn-close" data-bs-dismiss="offcanvas"
					aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<img class="img-fluid" src="../assets/zhiyin.png">
			</div>
		</div>


	</div>
</template>


<script>
	import FlipCountdown from 'vue2-flip-countdown'
	import useClipboard from 'vue-clipboard3'
	import vueQr from 'vue-qr';
	const {
		toClipboard
	} = useClipboard(); //复制
	export default {
		components: {
			FlipCountdown,
			vueQr,
		},
		metaInfo () {
		  return {
			title: this.title,
			meta: [
			  { name: 'description', content: this.description },
			  { name: 'google-site-verification', content: this.googleSiteVerification },
			]
		  }
		},
		data() {
			return {
				appName: "",
				title:'',
				description:'',
				googleSiteVerification:'',
				headerImg: "",
				brandIcon: "",
				bgList: "",
				code:"",
				channelCode: "",
				online: "",
				showProgress: false, //显示进度条
				showCourse: false, //显示教程
				showTrust: "hideArea", //显示一键信任
				progress: 0,
				width: 'width:0%;',
				maxtime: 100,
				timer: null,
				download_progress: 'showArea', //显示下载进度
				domain: "" ,//域名
				qrcodeUrl:'',
				selectBrand:'zaloqq.com',//当前品牌
				onlineImg:'',
				online_area_css:"",//客服按钮高度
				downloadImg:'',
				download_area_css:"",//下载按钮高度
				showQrcode:"display:none",
			}
		},
		computed: {},
		created() {
			this.domain = document.domain;
			let brand = document.domain.replace("www.","");
			// 判断是否配置了域名，没配置默认
			if(gconf[brand]){
				this.selectBrand = brand;
			}
			this.appName = gconf[this.selectBrand].name,
			this.title = gconf[this.selectBrand].title;
			this.onlineImg = gconf[this.selectBrand].onlineImg;
			this.downloadImg = gconf[this.selectBrand].downloadImg;
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				this.online_area_css = "top:" + gconf[this.selectBrand].onlineTop_m;
				this.download_area_css = "top:" + gconf[this.selectBrand].downloadTop_m;
				this.showQrcode = "display:none";
			}else{
				this.online_area_css = "top:" + gconf[this.selectBrand].onlineTop_pc;
				this.download_area_css = "top:" + gconf[this.selectBrand].downloadTop_pc;
				this.showQrcode = "display:block";
			}
			if(gconf[this.selectBrand].description){
				this.description = gconf[this.selectBrand].description;
			}
			if(gconf[this.selectBrand].googleSiteVerification){
				this.googleSiteVerification = gconf[this.selectBrand].googleSiteVerification;
			}
			this.headerImg = gconf[this.selectBrand].header,
			this.brandIcon = gconf[this.selectBrand].icon,
			this.bgList = gconf[this.selectBrand].bgList,
			this.code = gconf[this.selectBrand].code;
			this.channelCode = gconf[this.selectBrand].channelCode,
			this.online = gconf[this.selectBrand].online,
			this.setIco(this.brandIcon);
			this.qrcodeUrl = window.location.href;
			this.tongji();
		},
		methods: {
			setIco(brandIcon){
				 let $favicon = document.querySelector('link[rel="icon"]');
				  if ($favicon !== null) {
					$favicon.href = brandIcon;
				  } else {
					$favicon = document.createElement("link");
					$favicon.rel = "icon";
					$favicon.href = brandIcon;
					document.head.appendChild($favicon);
				  }
			},
			jumpOnline(){
				window.location.href = this.online;
			},
			tongji() {
				//百度统计
				if (gconf[this.selectBrand].baiduId) {
					var hm = document.createElement("script");
					hm.src = "https://hm.baidu.com/hm.js?" + gconf[this.selectBrand].baiduId;
					var s = document.getElementsByTagName("script")[0];
					s.parentNode.insertBefore(hm, s);
				}
			},
			getUrlParam(name) { // 获取url中携带的参数
				//构造一个含有目标参数的正则表达式对象
				let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				let _url = window.location.search;
				//匹配目标参数
				let r = _url.substr(1).match(reg);
				//返回参数值
				if (r != null) {
					return decodeURI(r[2]);
				}
				return null;
			},
			guid() { 
			    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { 
			        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8); 
			        return v.toString(16); 
			    }); 
			},
			// 下载app
			install() {
				var copyText = {};
				let _channel_code = this.getUrlParam("channel_code");
				if (_channel_code) {
					this.channelCode = _channel_code;
				} else {
					this.channelCode = gconf[this.selectBrand].channelCode;
				}
				let _code = this.getUrlParam("code");
				if (_code) {
					this.channelCode = "";
					copyText = {
						"channel_code": "20000000000",
						"code": _code,
						"uuid": this.guid(),
					};
				} else {
					copyText = {
						"channel_code": this.channelCode,
						"uuid": this.guid(),
					};
				}
				//复制
				toClipboard(JSON.stringify(copyText));

				const u = navigator.userAgent;
				const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if (isiOS) { // IOS 
					this.ios();
				} else { // android
					this.android();
				}
			},
			android() { //下载安卓
				window.location.href = gconf[this.selectBrand].android;
			},
			ios() {
				//webClip
				if (gconf[this.selectBrand].openWebClip) {
					window.location.href = gconf[this.selectBrand].webClipDomain + "shouye/" + this.channelCode + "." + gconf[this.selectBrand]
						.appkey;
					return;
				}
				//超级签
				if (gconf[this.selectBrand].ios && gconf[this.selectBrand].ios.indexOf(".plist") < 0) {
					window.location.href = gconf[this.selectBrand].ios;
					return;
				}
				// 采用企业签
				this.showProgress = true; //显示下载进度
				this.download_progress = true;
				var _domain, _time1, _time2;
				if (gconf[this.selectBrand].ios && gconf[this.selectBrand].ios.indexOf(".plist") > -1) {
					_domain = "itms-services://?action=download-manifest&url=" + gconf[this.selectBrand].ios;
					_time1 = 200;
					_time2 = 300;
				}
				const that = this;
				setTimeout(function() {
					setInterval(function() {
						that.timer = that.countdown();
					}, _time2);
				}, _time1);
				window.location.href = _domain;
			},
			countdown() {
				if (this.maxtime >= 0) {
					--this.maxtime;
					this.progress++;
					this.width = "width:" + this.progress + "%;";
				} else {
					clearInterval(this.timer);
					this.showTrust = 'showArea';
					this.download_progress = 'hideArea';
				}
			},
			closeDownload() { //关闭安装进度
				this.showProgress = false;
			},
			viewCourse() { //查看教学
				this.showCourse = true;
			},
			closeCourse() { //关闭教学
				this.showCourse = false;
			},
			allowIos() { //一键信任
				window.location.href = "../embedded.mobileprovision";
			},
		}
	}
</script>


<style>
	.container {
		max-width: 800px;
		margin: auto;
	}
	.online-area{
		position: absolute;
		z-index: 4;
		cursor: pointer;
		top: 6.8rem;
	}
	.online-area img{
		height: 50px;
	}
	.download-area{
		position: absolute;
		z-index: 4;
		left: 0px;
		right: 0px;
		margin: auto;
		cursor: pointer;
		top: 49rem;
	}
	.download-area img{
		height: 60px;
	}
	
	
	.bottom img {
		height: 100px;
	}

	.footer {
		margin-top: 2rem;
		margin-bottom: 1rem;
		font-size: 18px;
		color: #3E3344;
		font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	}

	.offcanvas {
		border-radius: 30px;
		height: 15rem;
	}

	.hideArea {
		display: none;
	}

	.showArea {
		display: block;
	}

	.allow_title {
		color: rgba(51, 51, 51, var(--tw-text-opacity));
		font-weight: 600;
		font-size: 20px;
	}

	.allow_desc {
		font-size: 12px;
		color: rgba(153, 153, 153, var(--tw-text-opacity));
	}

	.allow_btn {
		margin-top: 2rem;
		width: 14rem;
	}

	#offcanvasBottom2 {
		height: 30rem;
	}

	.offcanvas-body {
		margin-top: 0.6rem;
	}

	.hidden {
		display: none;
	}

	.footer-fix {
		background: rgba(255, 255, 255, 0.77);
		box-shadow: 0 0 2px rgb(0 0 0 / 35%);
		z-index: 999;
		min-height: 1.4rem;
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		padding: 20px 10px;
		text-align: left;
	}

	.footer-fix img {
		width: 60px;
	}
	
	.footer-logo{
		width: 60px;
		height: auto;
		float: left;
	}
	
	.footer-center{
		float: left;
	}

	.footer-fix-title {
		font-size: 1rem;
		font-family: "微软雅黑";
		font-weight: bold;
		padding: 0.2rem 0 0 0.5rem;
		color: #333;
		margin-top: -10px;
	}

	.footer-fix-desc {
		font-size: 12px;
		padding-left: 0.3rem;
		font-family: "微软雅黑";
		font-weight: bold;
	}
	.footer-fix-btn{
		float: right;
	}
	
	.clear{
		clear: both;
	}
	
	.star {
		padding-left: 0.5rem;
	}

	.footer-fix .btn-primary {
		background: #43c117;
		width: 7rem;
		height: 3rem;
		margin-left: -3rem;
		border: 0px;
		margin-top: 0.4rem;
	}

	.comment {
		height: 8px;
		line-height: 8px;
		font-size: 12px;
		margin: 6px 0px;
	}

	.comment-one {
		border: 1px solid #1E9FFF;
		color: #1E9FFF;
		padding: 4px;
		display: inline-block;
		width: auto;
	}

	.comment-two {
		border: 1px solid #DC9245;
		color: #DC9245;
		padding: 4px;
		display: inline-block;
		width: auto;
	}

	.comment-three {
		border: 1px solid #60B551;
		color: #60B551;
		padding: 4px;
		display: inline-block;
		width: auto;
	}
	
	/* 动画 */
	.animated {
	    -webkit-animation-duration: 1s;
	    animation-duration: 1s;
	    -webkit-animation-fill-mode: both;
	    animation-fill-mode: both
	}
	
	.animated.infinite {
	    -webkit-animation-iteration-count: infinite;
	    animation-iteration-count: infinite
	}
	
	@-webkit-keyframes swing {
	    20% {
	        -webkit-transform: rotate(15deg);
	        transform: rotate(15deg)
	    }
	
	    40% {
	        -webkit-transform: rotate(-10deg);
	        transform: rotate(-10deg)
	    }
	
	    60% {
	        -webkit-transform: rotate(5deg);
	        transform: rotate(5deg)
	    }
	
	    80% {
	        -webkit-transform: rotate(-5deg);
	        transform: rotate(-5deg)
	    }
	
	    to {
	        -webkit-transform: rotate(0deg);
	        transform: rotate(0deg)
	    }
	}
	
	@keyframes swing {
	    20% {
	        -webkit-transform: rotate(15deg);
	        transform: rotate(15deg)
	    }
	
	    40% {
	        -webkit-transform: rotate(-10deg);
	        transform: rotate(-10deg)
	    }
	
	    60% {
	        -webkit-transform: rotate(5deg);
	        transform: rotate(5deg)
	    }
	
	    80% {
	        -webkit-transform: rotate(-5deg);
	        transform: rotate(-5deg)
	    }
	
	    to {
	        -webkit-transform: rotate(0deg);
	        transform: rotate(0deg)
	    }
	}
	
	.swing {
	    -webkit-transform-origin: center center;
	    transform-origin: center center;
	    -webkit-animation-name: swing;
	    animation-name: swing
	}
	
	@-webkit-keyframes bounce {
	    0%,20%,53%,80%,to {
	        -webkit-animation-timing-function: cubic-bezier(.215,.61,.355,1);
	        animation-timing-function: cubic-bezier(.215,.61,.355,1);
	        -webkit-transform: translateZ(0);
	        transform: translateZ(0)
	    }
	
	    40%,43% {
	        -webkit-transform: translate3d(0,-5px,0);
	        transform: translate3d(0,-5px,0)
	    }
	
	    40%,43%,70% {
	        -webkit-animation-timing-function: cubic-bezier(.755,.05,.855,.06);
	        animation-timing-function: cubic-bezier(.755,.05,.855,.06)
	    }
	
	    70% {
	        -webkit-transform: translate3d(0,-2px,0);
	        transform: translate3d(0,-2px,0)
	    }
	
	    90% {
	        -webkit-transform: translate3d(0,-2px,0);
	        transform: translate3d(0,-2px,0)
	    }
	}
	
	@keyframes bounce {
	    0%,20%,53%,80%,to {
	        -webkit-animation-timing-function: cubic-bezier(.215,.61,.355,1);
	        animation-timing-function: cubic-bezier(.215,.61,.355,1);
	        -webkit-transform: translateZ(0);
	        transform: translateZ(0)
	    }
	
	    40%,43% {
	        -webkit-transform: translate3d(0,-5px,0);
	        transform: translate3d(0,-5px,0)
	    }
	
	    40%,43%,70% {
	        -webkit-animation-timing-function: cubic-bezier(.755,.05,.855,.06);
	        animation-timing-function: cubic-bezier(.755,.05,.855,.06)
	    }
	
	    70% {
	        -webkit-transform: translate3d(0,-2px,0);
	        transform: translate3d(0,-2px,0)
	    }
	
	    90% {
	        -webkit-transform: translate3d(0,-2px,0);
	        transform: translate3d(0,-2px,0)
	    }
	}
	
	.bounce {
	    -webkit-animation-name: bounce;
	    animation-name: bounce;
	    -webkit-transform-origin: center bottom;
	    transform-origin: center bottom
	}
	
	
	@-webkit-keyframes tada {
	    0% {
	        -webkit-transform: scaleX(1);
	        transform: scaleX(1)
	    }
	
	    10%,20% {
	        -webkit-transform: scale3d(.9,.9,.9) rotate(-3deg);
	        transform: scale3d(.9,.9,.9) rotate(-3deg)
	    }
	
	    30%,50%,70%,90% {
	        -webkit-transform: scale3d(1.1,1.1,1.1) rotate(3deg);
	        transform: scale3d(1.1,1.1,1.1) rotate(3deg)
	    }
	
	    40%,60%,80% {
	        -webkit-transform: scale3d(1.1,1.1,1.1) rotate(-3deg);
	        transform: scale3d(1.1,1.1,1.1) rotate(-3deg)
	    }
	
	    to {
	        -webkit-transform: scaleX(1);
	        transform: scaleX(1)
	    }
	}
	
	@keyframes tada {
	    0% {
	        -webkit-transform: scaleX(1);
	        transform: scaleX(1)
	    }
	
	    10%,20% {
	        -webkit-transform: scale3d(.9,.9,.9) rotate(-3deg);
	        transform: scale3d(.9,.9,.9) rotate(-3deg)
	    }
	
	    30%,50%,70%,90% {
	        -webkit-transform: scale3d(1.1,1.1,1.1) rotate(3deg);
	        transform: scale3d(1.1,1.1,1.1) rotate(3deg)
	    }
	
	    40%,60%,80% {
	        -webkit-transform: scale3d(1.1,1.1,1.1) rotate(-3deg);
	        transform: scale3d(1.1,1.1,1.1) rotate(-3deg)
	    }
	
	    to {
	        -webkit-transform: scaleX(1);
	        transform: scaleX(1)
	    }
	}
	
	.tada {
	    -webkit-animation-name: tada;
	    animation-name: tada
	}
	
	@-webkit-keyframes wobble {
	    0% {
	        -webkit-transform: none;
	        transform: none
	    }
	
	    15% {
	        -webkit-transform: translate3d(-25%,0,0) rotate(-5deg);
	        transform: translate3d(-25%,0,0) rotate(-5deg)
	    }
	
	    30% {
	        -webkit-transform: translate3d(20%,0,0) rotate(3deg);
	        transform: translate3d(20%,0,0) rotate(3deg)
	    }
	
	    45% {
	        -webkit-transform: translate3d(-15%,0,0) rotate(-3deg);
	        transform: translate3d(-15%,0,0) rotate(-3deg)
	    }
	
	    60% {
	        -webkit-transform: translate3d(10%,0,0) rotate(2deg);
	        transform: translate3d(10%,0,0) rotate(2deg)
	    }
	
	    75% {
	        -webkit-transform: translate3d(-5%,0,0) rotate(-1deg);
	        transform: translate3d(-5%,0,0) rotate(-1deg)
	    }
	
	    to {
	        -webkit-transform: none;
	        transform: none
	    }
	}
	
	@keyframes wobble {
	    0% {
	        -webkit-transform: none;
	        transform: none
	    }
	
	    15% {
	        -webkit-transform: translate3d(-25%,0,0) rotate(-5deg);
	        transform: translate3d(-25%,0,0) rotate(-5deg)
	    }
	
	    30% {
	        -webkit-transform: translate3d(20%,0,0) rotate(3deg);
	        transform: translate3d(20%,0,0) rotate(3deg)
	    }
	
	    45% {
	        -webkit-transform: translate3d(-15%,0,0) rotate(-3deg);
	        transform: translate3d(-15%,0,0) rotate(-3deg)
	    }
	
	    60% {
	        -webkit-transform: translate3d(10%,0,0) rotate(2deg);
	        transform: translate3d(10%,0,0) rotate(2deg)
	    }
	
	    75% {
	        -webkit-transform: translate3d(-5%,0,0) rotate(-1deg);
	        transform: translate3d(-5%,0,0) rotate(-1deg)
	    }
	
	    to {
	        -webkit-transform: none;
	        transform: none
	    }
	}
	
	.wobble {
	    -webkit-animation-name: wobble;
	    animation-name: wobble
	}
</style>
